<template>
  <stacked-bar-with-prior-year
    :chart-data="chartData"
    :loading="loading"
    chart-v-ax-format=""
    v-on:bar-selected="triggerBarSelect"
    :bus="bus"
  ></stacked-bar-with-prior-year>
</template>

<script>
import StackedBar from "../../../charts/StackedBar";
import Vue from "vue";
import StackedBarWithPriorYear from "../../../charts/StackedBarWithPriorYear.vue";

export default {
  name: "ConversionCount",
  data() {
    return {
      loading: false,
    }
  },
  props: ['date-range', 'updateData', 'viewData', 'bus'],
  components: {StackedBarWithPriorYear},
  computed: {
    chartData: function() {
      return this.viewData
    }
  },
  methods: {
    triggerBarSelect(event) {
      this.$emit('conversion-bar-selected', event);
    }
  }
}
</script>

<style scoped>

</style>
